module.exports = __webpack_public_path__ + "static/media/29BDOS24.8edabc92.jpg";